import { ref, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { getUnreadMessage } from "@/api/order";

export function useUnreadMessage(interval = 10000) {
  const timer = ref<NodeJS.Timer | null>(null);
  const isPolling = ref(false); // 添加状态跟踪
  const unreadCount = ref(0);
  const store = useStore();
  const clearBadgeAndNotification = () => {
    // 清除角标，传入空字符串
    window.electronAPI.setBadge("", false);
    // 重置计数
    unreadCount.value = 0;
  };

  const sendNotifications = (messages: string[]) => {
    // 遍历发送所有新消息
    messages.forEach((message) => {
      window.electronAPI.sendNotification("数据已准备完成", message);
    });
  };
  const queryUnreadMessage = async () => {
    try {
      const res = await getUnreadMessage();
      const { totalCount, datasetOrderCount, apiOrderCount, orderNoticeList } =
        res;

      // 更新 Vuex store
      store.commit("message/setUnreadCounts", {
        totalCount,
        datasetOrderCount,
        apiOrderCount,
        orderNoticeList,
      });

      // 更新未读消息数量
      if (totalCount > 0) {
        window.electronAPI.setBadge(
          String(totalCount),
          orderNoticeList?.length > 0
        );
        unreadCount.value = totalCount;
      } else {
        window.electronAPI.setBadge("", false);
        unreadCount.value = 0;
      }

      // 如果有新通知，发送系统通知
      if (orderNoticeList?.length > 0) {
        sendNotifications(orderNoticeList);
      }
    } catch (error) {
      console.error("Query unread message failed:", error);
    }
  };

  const startPolling = () => {
    if (isPolling.value) {
      console.log("轮询已在进行中，避免重复启动");
      return;
    }
    isPolling.value = true;
    // 立即执行一次
    queryUnreadMessage();

    // 设置定时器
    timer.value = setInterval(queryUnreadMessage, interval);
  };

  const stopPolling = () => {
    console.log("停止轮询");
    if (timer.value) {
      clearInterval(timer.value);
      timer.value = null;
      isPolling.value = false;
      clearBadgeAndNotification();
      console.log("轮询已停止");
    }
  };

  onUnmounted(() => {
    console.log("组件卸载");
    stopPolling();
  });

  return {
    unreadCount,
    startPolling,
    stopPolling,
    isPolling,
  };
}
